
import {
  computed, defineComponent, onMounted, reactive, ref,
} from 'vue';

import AppHeader from '@/components/AppHeader.vue';
import AddGroupImage from '@/modules/spaces/components/AddGroupImage.vue';
import { IGroupData, IPhoto } from '@/types/interfaces';
import SpacesService from '@/modules/spaces/services/SpacesService';
import { lowResUrlByViewTypeByUrl } from '@/helpers/lowResPhotoUrl';
import { PHOTO_VIEW_TYPE } from '@/types/enums';

export default defineComponent({
  components: {
    AppHeader,
    AddGroupImage,
  },
  props: {
    prevData: { type: Object, required: true },
  },
  setup(props, context) {
    const payload = ref({});

    const groupCover = computed(() => {
      const coverUrl = props.prevData.photo?.url;
      return coverUrl ? lowResUrlByViewTypeByUrl(coverUrl, PHOTO_VIEW_TYPE.WHSML) : '';
    });
    const groupInfo = ref({} as IGroupData);
    const formData = reactive({
      groupName: '',
      groupInfo: '',
    });

    function handleUpdateCoverPhoto(cover: IPhoto) {
      groupInfo.value.photo = cover;
    }

    function updateGroupData() {
      if (formData.groupName.trim() === '' && formData.groupInfo.trim() === '') {
        context.emit('on-cancel');
        return;
      } if (formData.groupName.trim() === '') {
        payload.value = { ...props.prevData, groupInfo: formData.groupInfo };
      } if (formData.groupInfo.trim() === '') {
        payload.value = { ...props.prevData, name: formData.groupName };
      } else {
        payload.value = { ...props.prevData, name: formData.groupName, groupInfo: formData.groupInfo };
      }
      SpacesService.updateGroup(payload.value).then((res) => {
        if (res.success) {
          const groupData = res.results.data;
          context.emit('on-done', groupData);
        }
      });
    }

    function editValues() {
      formData.groupName = props.prevData.name;
      formData.groupInfo = props.prevData.groupInfo;
    }

    onMounted(() => {
      editValues();
    });

    return {
      groupCover,
      formData,
      groupInfo,
      editValues,
      updateGroupData,
      handleUpdateCoverPhoto,
    };
  },
});
